<template>
  <el-config-provider :locale="locale">
    <router-view> </router-view>
  </el-config-provider>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import enLocale from "element-plus/lib/locale/lang/en";
import viLocale from "element-plus/lib/locale/lang/vi";
import { langWeb } from "@/stores/lang";
import mushroom from "cem-primary-api";
import Swal from "sweetalert2";
import { useI18n } from "vue-i18n";
import MethodService from "@/service/MethodService";

const { t } = useI18n();
const router = useRouter();
const lang_web = langWeb();

const locale = computed(() => {
  const langState = lang_web.showLang;
  const local = langState === "vi" ? viLocale : enLocale;
  return local;
});

const checkNoneWebGUIRole = (userInfo) => {
  try {
    if (!userInfo?.roles?.includes("NoneWebGUI")) return false;
    const roles = userInfo.roles;
    const otherRoles = roles.filter(
      (role) => role !== "NoneWebGUI" && role !== "QueryAPI" && role !== "User",
    );

    if (otherRoles.length === 0) {
      window.localStorage.clear();

      Swal.fire({
        title: t("t_warning"),
        text: t("t_not_access"),
        icon: "warning",
        confirmButtonColor: "#3085d6",
        confirmButtonText: t("swal_accept"),
        allowOutsideClick: false,
      }).then(async () => {
        try {
          await mushroom.$auth.logoutAsync({ mode: "invalidClientSession" });
        } catch (e) {
          console.error("Có lỗi: %o", e);
        }
        router.push("/login");
      });
      return true;
    }
    return false;
  } catch (e) {
    console.error(e);
    return false;
  }
};

const checkPasswordPolicy = async (userInfo) => {
  if (!userInfo) return;
  await MethodService.checkNeedToChangePassword({ router, t });
};

onMounted(() => {
  const userInfoFromLocalStogare = localStorage.getItem("userInfo");
  if (!userInfoFromLocalStogare) return;

  try {
    const userInfo = JSON.parse(userInfoFromLocalStogare)?.result;
    const isBlocked = checkNoneWebGUIRole(userInfo);
    if (!isBlocked) {
      checkPasswordPolicy(userInfo);
    }
  } catch (e) {
    console.error("error:", e);
  }
});
</script>
